// Updated App.js with better background handling
import React from 'react';
import ScrollToTop from './components/ScrollToTop';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TeamPage from './pages/TeamPage';
import PlayerPage from './pages/PlayerPage';
import NewsPage from './pages/NewsPage';
import ArticlePage from './pages/ArticlePage';
import SchedulePage from './pages/SchedulePage';
import CoachesPage from './pages/CoachesPage';
import SponsorsPage from './pages/SponsorsPage';
import VideoLibrary from './components/VideoLibrary';
import StatsPage from './pages/StatsPage';
import ForwardsStatsPage from './pages/ForwardsStatsPage';
import DefenseStatsPage from './pages/DefenseStatsPage';
import GoaliesStatsPage from './pages/GoaliesStatsPage';
import GameDetailsPage from './pages/GameDetailsPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-gradient-to-b from-black to-gray-900">
        <Header />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/coaches" element={<CoachesPage />} />
            <Route path="/players/:id" element={<PlayerPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:id" element={<ArticlePage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/games/:id" element={<GameDetailsPage />} />
            <Route path="/videos" element={<VideoLibrary />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/stats/:seasonId" element={<StatsPage />} />
            <Route path="/stats/forwards" element={<ForwardsStatsPage />} />
            <Route path="/stats/defense" element={<DefenseStatsPage />} />
            <Route path="/stats/goalies" element={<GoaliesStatsPage />} />
            <Route path="/stats/:seasonId/forwards" element={<ForwardsStatsPage />} />
            <Route path="/stats/:seasonId/defense" element={<DefenseStatsPage />} />
            <Route path="/stats/:seasonId/goalies" element={<GoaliesStatsPage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
